import { createContext, useContext, useEffect, useState } from 'react';
import { getUser } from '../services/users';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const currentUser = getUser();
  console.log(currentUser);
  const [user, setUser] = useState(
    currentUser
      ? {
          id: currentUser.id,
          email: currentUser.email,
        }
      : {}
  );

  const contextValue = { user, setUser };

  return (
    <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('Error: useUser needs to be used within UserContext');
  }
  return context;
};
